/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Toast_Failed_Delete_FolderInputs */



/**
* | output |
* | --- |
* | "Failed to delete folder and its contents" |
*
* @param {Spaces_Toast_Failed_Delete_FolderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_toast_failed_delete_folder = /** @type {((inputs?: Spaces_Toast_Failed_Delete_FolderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Toast_Failed_Delete_FolderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Löschen des Ordners und dessen Inhalte fehlgeschlagen")
	return /** @type {LocalizedString} */ ("Failed to delete folder and its contents")
});